import detail from "./detail";

export default {
  namespaced: true,
  modules: {
    detail,
  },
};
